import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';
import PartnersList from 'components/Admin/Partner/List'
import { push } from 'redux-router';
import Toolbar from 'components/Admin/Partner/Toolbar';

const {
  loadAdminPartnersSaga,
  showDeletePartnersConfirmationModal
} = actions;

class Partners extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      partner_ids: [],
      page: props.page || 1,
      query: {
        title: '',
        ...props.query
      }
    }
  }

  componentWillMount = () => {
    this.loadPartners();
  }

  deletePartners = () => {
    if (this.state.partner_ids.length > 0)
      this.props.deletePartners(this.state.partner_ids)
  }

  onChangePage = (page = 1) => {
    this.setState({
      page
    }, this.loadPartners);
  }

  checkedPartnerIds = (partner_id) => {
    var ids = _.assign(this.state.partner_ids),
      index = this.state.partner_ids.indexOf(partner_id);

    if (index == -1) {
      ids.push(partner_id)
    } else {
      ids.splice(index, 1)
    }
    this.setState({ partner_ids: ids })
  }

  loadPartners = () => this.props.loadPartners(this.state.page, this.state.query)

  changeQuery = (query, timeout = 500) => {
    this.setState({ query }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadPartners, timeout)
    })
  }

  onOrderChange = (field = 'created_at', order = 'desc') => {
    const query = {
      ...this.state.query,
      order: {
        [field]: order
      }
    }
    this.changeQuery(query, 0);
  }

  onChangeQuery = (field, value) => {
    const query = { ...this.state.query, ...{ [field]: value } };
    this.setState({ page: 1 }, () => {
      this.changeQuery(query)
    });
  }

  render() {
    const {
      deletePartners,
      state,
      onChangeQuery,
      onDateRangeChange
    } = this;
    return (
      <main className="site--width clearfix container_statistics">
        <div className="container_admin_sponsor">
        </div>
        <Toolbar
          filterProps={{
            ...state,
            onDateRangeChange,
            onChangeQuery
          }}
          toolsProps={{
            count: this.props.count,
            deletePartners
          }}
        />
        <div className="admin_sponsors_table admin_table">
          <PartnersList
            partners={this.props.partners}
            navigateToPartner={this.props.navigateToPartner}
            checkedPartnerIds={this.checkedPartnerIds}
            partner_ids={this.state.partner_ids}
            onOrderChange={this.onOrderChange}
            query={this.state.query}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    partners: state.partners.admin.list.values,
    count: state.partners.admin.list.count,
    total_pages: state.partners.admin.list.total_pages,
    page: state.partners.admin.list.page,
    query: state.partners.admin.list.query
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    navigateToPartner: (id) => dispatch(push(`/partnership/${id}`)),
    deletePartners: (partner_ids) => dispatch(showDeletePartnersConfirmationModal(partner_ids)),
    loadPartners: (page, query) => dispatch(loadAdminPartnersSaga(page, query))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Partners);



// WEBPACK FOOTER //
// ./src/containers/Admin/Partner/Partners.jsx